var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"lingua-indigena","rota-base":"/admin/lingua-indigena","titulo":"LÍNGUAS INDÍGENAS","titulo-singular":"Língua Indígena","colunas-extras":[{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":10}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }